import { useState } from "react";
import OtpVerifyScreen from "../login/OtpVerifyScreen";
import ForgotPassword from "./ForgotPassword";
import NewPassword from "./NewPassword";
import CreatePasswordIndex from "../create_password";

function ForgotPasswordIndex() {
  const [step, setStep] = useState(0);
  const [email, setEmail] = useState("");
  const [otpRefCode, setOtpRefCode] = useState("");
  const [userId, setUserId] = useState("");

  return (
    <>
      {step === 0 ? (
        <>
          <ForgotPassword
            onSuccess={(email, otpRefCode, userID) => {
              setEmail(email);
              setStep(1);
              setOtpRefCode(otpRefCode);
              setUserId(userID);
            }}
          />
        </>
      ) : step === 1 ? (
        <>
          <OtpVerifyScreen
            email={email}
            isFromForgotPass={true}
            onSuccess={(otpRefCode) => {
              setStep(2);
              setOtpRefCode(otpRefCode);
            }}
            otpRefCode={otpRefCode}
            userId={userId}
            forgotpassword={true}
          />
        </>
      ) : (
        step === 2 && (
          <>
            <NewPassword
              email={email}
              otpRefCode={otpRefCode}
              userId={userId}
            />
          </>
        )
      )}
    </>
  );
}

export default ForgotPasswordIndex;
